import { manualUpdate } from './utils';

function checkValue(str, max) {
	if (str.charAt(0) !== '0' || str == '00') {
		let num = parseInt(str);

		if (isNaN(num) || num <= 0 || num > max) {
			num = 1;
		}

		str = num > parseInt(max.toString().charAt(0)) && num.toString().length == 1 ? '0' + num : num.toString();
	};

	return str;
};

function manualFormat(input) {
	let value = input.value;

	if (/\D\/$/.test(value)) {
		value = value.substr(0, value.length - 3);
	}

	let values = value.split('/').map(function(v) {
		return v.replace(/\D/g, '')
	});

	if (values[0]) {
		values[0] = checkValue(values[0], 12);
	}
	if (values[1]) {
		values[1] = checkValue(values[1], 31);
	}

	const output = values.map(function(item, index) {
		console.log(item, index);
		return item.length == 2 && index < 2 ? item + ' / ' : item;
	});

	input.value = output.join('').substr(0, 14);
}

export const initManualFormat = (field) => {
	// if (!manualUpdate) {
		$(field).on('input', function(event) {
			const code = event.keyCode;

			if ( code != 37 && code != 38 && code != 39 && code != 40 ) {
				manualFormat(this);
			}
		});
	// }
}

export function eqRows(container) {
	const $tables = $(container).find('table');

	$tables.each(function() {
		const $body = $(this).find('tbody');
		const $rows = $body.find('tr');
		const row = '<tr class="pika-row"><td class="is-empty"></td><td class="is-empty"></td><td class="is-empty"></td><td class="is-empty"></td><td class="is-empty"></td><td class="is-empty"></td><td class="is-empty"></td></tr>';

		if ( $rows.length < 5 ) {
			$body.append($(row));
		}

		if ( $rows.length < 6 ) {
			$body.append($(row));
		}
	});
}
